import { render, staticRenderFns } from "./order-mode.vue?vue&type=template&id=58c1eefe&"
import script from "./order-mode.vue?vue&type=script&lang=js&"
export * from "./order-mode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports